import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PILLARS = [
  { icon: 'ri-file-search-line', key: 'validation' },
  { icon: 'ri-focus-3-line',     key: 'fit' },
  { icon: 'ri-scales-line',      key: 'cost' },
  { icon: 'ri-settings-4-line',  key: 'structure' },
  { icon: 'ri-route-line',       key: 'followup' },
];

export default function CartaCurationSection() {
  const { t } = useTranslation('home');
  const pillars = t('cartaCuration.pillars', { returnObjects: true }) as Array<{
    label: string;
    title: string;
    description: string;
  }>;

  return (
    <section className="bg-[#0B0B0B] py-28 relative overflow-hidden">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 39px, #F97700 39px, #F97700 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, #F97700 39px, #F97700 40px)'
      }} />

      <div className="max-w-[1440px] mx-auto px-8 lg:px-16 relative z-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-[600px]">
            <p className="text-[11px] uppercase tracking-[0.12em] font-medium text-[#F97700] mb-4">
              {t('cartaCuration.eyebrow')}
            </p>
            <h2 className="text-4xl font-semibold text-white leading-[1.2] mb-5">
              {t('cartaCuration.title')}
            </h2>
            <p className="text-[15px] text-[#C8C0B4] leading-relaxed">
              {t('cartaCuration.subtitle')}
            </p>
          </div>
          <div className="flex-shrink-0">
            <Link
              to="/cartas-contempladas"
              className="inline-flex items-center gap-3 px-7 py-3.5 border border-white/20 text-white text-[13px] font-medium rounded hover:border-[#F97700] hover:text-[#F97700] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('cartaCuration.cta')}
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>

        {/* Pillars — horizontal strip */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/8">
          {Array.isArray(pillars) && PILLARS.map(({ icon, key }, i) => {
            const pillar = pillars[i];
            if (!pillar) return null;
            return (
              <div
                key={key}
                className="group bg-[#0B0B0B] p-7 hover:bg-[#141414] transition-colors duration-300 cursor-default"
              >
                {/* Icon */}
                <div className="w-9 h-9 flex items-center justify-center mb-5">
                  <i className={`${icon} text-2xl text-[#F97700]`}></i>
                </div>

                {/* Number */}
                <p className="text-[10px] font-mono text-[#5A5248] mb-3 tracking-widest">
                  0{i + 1}
                </p>

                {/* Title */}
                <h3 className="text-[15px] font-semibold text-white mb-3 leading-snug group-hover:text-[#F97700] transition-colors duration-300">
                  {pillar.title}
                </h3>

                {/* Description */}
                <p className="text-[13px] text-[#7A7268] leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom statement */}
        <div className="mt-12 border-t border-white/8 pt-10 max-w-[680px]">
          <p className="text-[14px] text-[#9A9288] leading-relaxed italic">
            {t('cartaCuration.statement')}
          </p>
        </div>
      </div>
    </section>
  );
}
